import styled from "styled-components";

const RegistryStyled = styled.div`

width: 100%;
height: 114px;

background: #A328D6;
border-radius: 5px;

padding: 10px;

display: flex;
flex-direction:column;
align-items: flex-start;
justify-content: space-between;

h1{
  font-style: normal;
  font-weight: bold;
  font-size: 17px;
  line-height: 20px;

  color: #FFFFFF;
}

img{
  height: 25px;
}

`;

export default RegistryStyled;